import {
  SERVICES_ACCESS,
  SERVICES_CONTANTS,
  SERVICES_ORDER_TO_SHOW,
  SERVICES_TO_FILL,
  COMPLETE_SERVICE_TO_FILL,
  SERVICE_STATES,
  SERVICE_STATE_COLORS,
  SERVICE_TYPES,
  CANCEL_SERVICE_ORDER_STATES,
  CANCELED_SERVICE_BANNED_STATES,
  FILTERS_NAME,
  SERVICES_ORDER_TO_NOT_SHOW
} from "@/modules/Services/constants/ServicesConstants";
import DocumentViewer from "@/shared/components/DocumentViewer/DocumentViewer.vue";
import { ServiceHeaderData } from "@/modules/Services/models/ServiceHeaderData";
import { ServicesService } from "@/modules/Services/services/ServicesService";
import { FormsService } from "@/modules/Forms/services/FormService";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES, LOCAL_STORAGE } from "@/shared/constants/FormConstants";
import {
  GENERAL_CONSTANTS,
  NAME_FINDERS,
  PANEL_INFO_CONSTANTS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { SearchFilter } from "@/shared/models/SearchFilter";
import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  COMPLETE_SERVICE,
  FILTER_SEARCH_SERVICE_PROFILE,
  GROUPS_SERVICE,
  MAX_WIDTH_MODALS,
  PROFILE_CONSTANTS,
  SECTIONS_SERVICE,
  SERVICELIST_ID
} from "../../constants/ProfileConstants";
import FilterSearch from "../FilterSearch/FilterSearch.vue";
import Appointment from "../Appointment/Appointment.vue";
import GeneratePdf from "../GeneratePdf/GeneratePdf.vue";
import PreviewPdf from "../GeneratePdf/components/PreviewPdf/PreviewPdf.vue";
import MedicalOrder from "../../../MedicalOrder/MedicalOrder.vue";
import MedicalOrderDetail from "../../../MedicalOrder/components/MedicalOrderDetail/MedicalOrderDetail.vue";
import Vuetify from "vuetify";
import { FieldGroup } from "@/modules/InfoGroup/models/FieldGroup";
import {
  FORMS_STATES,
  GENERATE_PDF_CONSTANTS
} from "../GeneratePdf/constants/generate-pdf.contants";
import { Service } from "@/modules/Services/models/Service";
import { SectionGroupDetail } from "@/modules/ServiceTemplate/models/SectionGroupDetail";
import SearchOneFilter from "./../../../../shared/components/GenericSearchBar/components/SearchOneFilter/SearchOneFilter.vue";
import {
  ItemFilterObj,
  QueryFilter
} from "@/shared/components/GenericSearchBar/model/FilterOneItem";
import { ID_FILTER } from "@/shared/components/GenericSearchBar/constants/GenericSearchConstants";
import { DocumentService } from "@/modules/Document/services/DocumentService";
import store from "@/store";
import { ORDER_CONSTANTS } from "@/modules/Orders/constants/OrderConstants";
import { MedicalOrderService } from "@/modules/MedicalOrder/services/MedicalOrderService";
import { ACTION_MESSAGE } from "@/modules/Dashboards/AdminDashboard/constants/ActionConstants";
import { AvailabilityService } from "@/modules/Availability/services/AvailabilityService";
import { MedicalOrderPreviewEventTimelineModel } from "@/modules/MedicalOrder/models/MedicalOrderPreviewEventTimelineModel";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { GO_TO_TOP } from "@/modules/Home/constants/HomeConstants";
import { EventDataDTO } from "@/modules/Events/models/event.model";
import ModalDetails from "../../../Events/components/ModalDetails/ModalDetails.vue";
import { EventService } from "@/modules/Events/services/EventService";
import { AxiosError } from "axios";
import {
  EVENTS_ACCESS,
  EVENT_MESSAGES
} from "@/modules/Events/constants/EventConstants";
import { ServiceQuery } from "@/modules/Services/models/ServiceQuery";
import ChangeStateService from "../ChangeStateService/ChangeStateService.vue";
import _ from "lodash";
import { ListService } from "@/modules/List/services/ListService";
import { ChatService } from "@/modules/Home/components/ChatWindow/Services/ChatWindow.service";
import { CHAT_ACTIONS } from "@/modules/Home/components/ChatWindow/Constants/ChatWindow.constants";
import { IMG_SOURCE } from "@/shared/components/ChatBot/constants/ChatBotConstants";
import SpecialistSignature from "../SpecialistSignature/SpecialistSignature.vue";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";

Vue.use(Vuetify);
@Component({
  name: "ListServices",
  components: {
    GeneratePdf,
    EmptyState,
    ModalTemplate,
    FilterSearch,
    SearchOneFilter,
    Appointment,
    PreviewPdf,
    DocumentViewer,
    MedicalOrder,
    MedicalOrderDetail,
    ModalDetails,
    ChangeStateService,
    SpecialistSignature
  },
  computed: {
    ...mapGetters({
      serviceOnChangeValidation: "getOnChangeServiceValidation",
      userActive: "getUserState",
      medicalOrderValidation: "getMedicalOrderValidation",
      dataToMainViewStore: "getDataToMainView"
    })
  }
})
export default class ListServices extends Vue {
  @Prop() public userId!: string;
  @Prop() public isInPanel!: boolean;
  @Prop() private serviceId?: string;
  @Prop() private refresh!: boolean;

  @Inject() servicesService!: ServicesService;
  @Inject() documentService!: DocumentService;
  @Inject() medicalOrderService!: MedicalOrderService;
  @Inject() availabilityService!: AvailabilityService;
  @Inject() formTemplateService!: FormTemplateService;
  @Inject() formsService!: FormsService;
  @Inject() eventService!: EventService;
  @Inject() listService!: ListService;
  @Inject() chatService!: ChatService;
  @Inject() serviceTemplateService!: ServiceTemplateService;

  dataToLateralMenu!: MenuDataStructure;
  serviceOnChangeValidation!: boolean;
  userActive!: boolean;
  medicalOrderValidation!: boolean;
  dataToMainViewStore!: MenuDataStructure;

  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  EMPTY_TITLE = PROFILE_CONSTANTS.EMPTY_TITLE_SERVICES;
  EMPTY_TEXT = PROFILE_CONSTANTS.EMPTY_TEXT_SERVICES;
  EMPTY_TEXT_FILTER = PROFILE_CONSTANTS.EMPTY_TEXT_SERVICES_FILTER;
  SERVICES_TITLE = SERVICES_CONTANTS.SERVICES_TITLE;
  COLORS: { [key: string]: string } = SERVICE_STATE_COLORS;
  SCHEDULE_APPOINTMENT = SERVICES_CONTANTS.LABEL.SCHEDULE_APPOINTMENT;
  APPOINTMENT_DETAIL = SERVICES_CONTANTS.LABEL.APPOINTMENT_DETAIL;
  REQUIRED_PRIOR_ORDER = SERVICES_CONTANTS.MESSAGE.REQUIRED_PRIOR_ORDER;
  COMPLETE_SERVICE_BTN = SERVICES_CONTANTS.BUTTON.COMPLETE_SERVICE;
  VIEW_ORDER_BTN = ORDER_CONSTANTS.BUTTON.VIEW_ORDER;
  CANCEL_SERVICE = SERVICES_CONTANTS.BUTTON.CANCEL_SERVICE;
  VIEW_SERVICE_NOTES = SERVICES_CONTANTS.BUTTON.VIEW_SERVICE_NOTES;
  COMPLETE_SERVICE_STATE = COMPLETE_SERVICE;
  SECTION_TYPE_SERVICE = SECTIONS_SERVICE;
  GROUP_TYPE_SERVICE = GROUPS_SERVICE;
  MAX_WIDTH = MAX_WIDTH_MODALS;
  CANCEL_SERVICE_ORDER_STATES = CANCEL_SERVICE_ORDER_STATES;
  CANCELED_SERVICE_BANNED_STATES = CANCELED_SERVICE_BANNED_STATES;
  GO_TO_TOP_BTN = GO_TO_TOP;

  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  modalConfirmationText = PROFILE_CONSTANTS.DIALOG_MESSAGES.CHANGE_SERVICE_TEXT;
  modalConfirmationTitle =
    PROFILE_CONSTANTS.DIALOG_MESSAGES.CHANGE_SERVICE_TITLE;
  dialogConfirmation = false;

  allowSend = SERVICES_TO_FILL;
  stateList = SERVICES_ORDER_TO_SHOW;
  servicesList: ServiceHeaderData[] = [];
  serviceCompleted = false;
  loadingServices = false;
  fillByStep = false;
  loading = true;
  isGeneratingSummary = false;
  summaryLoadingServiceId = "";
  menuOpenByServiceId: { [key: string]: boolean } = {};
  empty = false;
  showModalNotes = false;
  chosenService = "";
  chosenServiceType = "";
  eventData: EventDataDTO = {
    userId: this.userId,
    type: "",
    notes: []
  };

  dataToMainView = {};
  serviceSelected = "";
  lastService = "";
  showModalMedicalOrder = false;
  appointmentService = "";
  showGoTopBtn = false;
  SERVICELIST_ID = SERVICELIST_ID;
  NOTES = "notes";
  SERVICE = "servicio";

  generalData: ServiceHeaderData[] = [];

  filterItems: SearchFilter[] = [
    {
      name: PROFILE_CONSTANTS.FILTER_NAMES_TAGS.SERVICES[0],
      value: "",
      id: PROFILE_CONSTANTS.CHOSEN_SERVICES.SERVICES.SUB.CATEGORY,
      active: false
    },
    {
      name: PROFILE_CONSTANTS.FILTER_NAMES_TAGS.SERVICES[1],
      value: "",
      id: PROFILE_CONSTANTS.CHOSEN_SERVICES.SERVICES.SUB.STATE,
      active: false
    }
  ];
  showModalAppointment = false;
  medicalAppointmentSelected = "";
  serviceNameSelected = "";
  serviceTemplateSelected = "";
  serviceAppointment = "";
  canSeeServiceDetail = false;
  GENERATE_PDF_LABEL = PROFILE_CONSTANTS.LABELS.GENERATE_PDF;
  PREVIEW_PDF_LABEL = PROFILE_CONSTANTS.LABELS.PREVIEW;
  CHANGE_SERVICE_STATE = PROFILE_CONSTANTS.LABELS.CHANGE_SERVICE_STATE;
  SUMMARY = "Resumen";
  INVOICE_SERVICE = PROFILE_CONSTANTS.LABELS.INVOICE_SERVICE;
  SERVICE_COMPLETED = SERVICE_STATES.COMPLETED;
  BILLED_SERVICE = SERVICE_STATES.INVOICE;
  dialogConfirmationGeneratePdf = false;
  dialogConfirmationPreviewPdf = false;
  serviceSelectedData: Service = {} as Service;
  templatePdfId!: string;
  choosenFieldsPatient!: FieldGroup[];
  choosenFieldsDoctor!: FieldGroup[];
  formsSelected!: string[];
  fieldsSelected: { [form: string]: string[] } = {};
  service!: ServiceHeaderData;
  medicalOrder!: MedicalOrderPreviewEventTimelineModel;
  cupsId = "";
  currentService: ServiceHeaderData = {} as ServiceHeaderData;
  doctorInfoId = "";
  patientInfoId = "";
  sectionGroupDetail: SectionGroupDetail[] = [];
  documentDialog = false;
  documentName = "";
  documentURL = "";
  orderUserId = "";
  medicalOrderData = "";
  medicalOrdersValidation = false;
  serviceLastRef = "";
  searchQuery = "";
  IMG_SOURCE = IMG_SOURCE;

  SERVICE_CONTEXTUAL_KEY = NAME_FINDERS.SERVICE_CONTEXTUAL;
  itemFilter = {
    ...FILTER_SEARCH_SERVICE_PROFILE
  };

  filtern: QueryFilter = {};
  showStateServiceModal = false;
  serviceToChangeState: ServiceHeaderData = {} as ServiceHeaderData;
  specialistSignatureDialog = false;

  selectItem(item: ItemFilterObj) {
    if (!item || !item.name || !item.type) {
      this.filtern = {};
      return;
    }
    this.filtern = { [item.type]: item.name };
  }

  filterOut(filter: QueryFilter) {
    this.filtern = filter;
  }

  get listCategory(): ItemFilterObj[] {
    return (
      this.generalData?.map(service => ({
        id: service.category,
        name: service.category
      })) ?? []
    );
  }

  get listState(): ItemFilterObj[] {
    return (
      this.generalData?.map(service => ({
        id: service.state,
        name: service.visualStateName!
      })) ?? []
    );
  }

  get ListActual() {
    const filterKeys = Object.keys(this.filtern);
    if (filterKeys.length == 0) {
      return this.generalData;
    }
    const filterText = this.filtern[filterKeys[0]]?.toUpperCase();
    if (!filterText) {
      return this.generalData;
    }
    const filterKey = filterKeys[0];
    return (
      this.generalData?.filter(service => {
        if (filterKey == ID_FILTER.INTERNAL_NAME) {
          return service.internalName?.toUpperCase().includes(filterText);
        }
        if (filterKey == ID_FILTER.CATEGORY) {
          return service.category?.toUpperCase() == filterText;
        }
        if (filterKey == ID_FILTER.STATE) {
          return service.visualStateName?.toUpperCase() == filterText;
        }
      }) ?? []
    );
  }

  async mounted() {
    this.serviceSelected = this.serviceId ?? "";
    await this.getServices();

    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);

    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.SEE_SERVICE_DETAIL
      )
    ) {
      this.canSeeServiceDetail = true;
    }
  }

  @Watch("serviceOnChangeValidation")
  watchServiceValidation() {
    return this.serviceOnChangeValidation;
  }

  @Watch("serviceId")
  async watchServiceId() {
    if (
      this.serviceId !== "" &&
      !this.isInPanel &&
      this.servicesList.length > 0
    ) {
      const indexSelected = this.servicesList.findIndex(
        service => service.id == this.serviceId
      );

      if (indexSelected >= 0) {
        this.getServiceData(this.servicesList[indexSelected]);
      } else if (indexSelected <= 0 && this.serviceId != "") {
        const servicesState = JSON.stringify(COMPLETE_SERVICE_TO_FILL);
        const responseData = this.isInPanel
          ? await this.servicesService.getServicesByType(this.userId, "")
          : await this.servicesService.getServicesByType(
              this.userId,
              "",
              servicesState
            );
        const completeHeader = responseData.data?.find(completeService => {
          return completeService.id === this.serviceId;
        });
        this.getServiceData(completeHeader!);
      }
    }
  }

  openModalPreviewPdf(
    close: boolean,
    templatePdfId?: string,
    choosenFieldsPatient?: FieldGroup[],
    choosenFieldsDoctor?: FieldGroup[],
    formsSelected?: string[],
    service?: ServiceHeaderData,
    fieldsSelected?: { [form: string]: string[] }
  ) {
    if (close) return (this.dialogConfirmationPreviewPdf = false);
    this.templatePdfId = templatePdfId!;
    this.choosenFieldsPatient = choosenFieldsPatient!;
    this.choosenFieldsDoctor = choosenFieldsDoctor!;
    this.formsSelected = formsSelected!;
    this.service = service!;
    this.dialogConfirmationPreviewPdf = !this.dialogConfirmationPreviewPdf;
    this.fieldsSelected = fieldsSelected!;
  }

  async getFormById(id: string) {
    try {
      const response = await this.formsService.getFormModelById(id);
      if (response?.data) {
        return response.data.fields;
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
          : GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_GET_SERVICE;

      Snackbar.popError(errorMessage);
    }
  }

  async getSectionsService(serviceId: string) {
    try {
      const response = await this.servicesService.getServiceData({
        userId: this.$props.id,
        serviceId: serviceId
      });
      if (!response?.data?.sections) return;

      for (const section of response.data.sections) {
        for (const form of section.formTemplates as SectionGroupDetail[]) {
          if (form.state !== FORMS_STATES.COMPLETE) return;

          const formFields = await this.getFormById(form?.form ?? "");
          const formWithFields = {
            ...form,
            fields: formFields
          };
          this.sectionGroupDetail.push(formWithFields as SectionGroupDetail);
        }
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
          : GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_GET_SERVICE;

      Snackbar.popError(errorMessage);
    }
  }

  async openModalGeneratePdf(open: boolean, service?: ServiceHeaderData) {
    try {
      if (!service) {
        this.dialogConfirmationGeneratePdf = open;
        this.sectionGroupDetail = [];
        return;
      }
      await this.getSectionsService(service.id);
      const response = await this.servicesService.getServiceById(service.id);
      if (response.code !== Http.Found) {
        return Snackbar.popError(response.message);
      }
      this.serviceSelectedData = response.data;
      this.doctorInfoId = response.data.attendedBy;
      this.patientInfoId = response.data.user;
      this.dialogConfirmationGeneratePdf = open;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
          : GENERATE_PDF_CONSTANTS.MESSAGES.ERROR_GET_SERVICE;

      Snackbar.popError(errorMessage);
    }
  }

  orderAndGroupByState(services: ServiceHeaderData[]) {
    const result: ServiceHeaderData[] = [];

    this.stateList.forEach(state => {
      const group = services
        .filter(i => i.state === state)
        .sort((a, b) => b.dateChanged - a.dateChanged);

      if (group.length > 0) result.push(...group);
    });

    return result;
  }

  handleEnterPressed(value: string) {
    this.searchQuery = value;
  }

  @Watch("refresh")
  @Watch("searchQuery")
  async refreshSearch() {
    this.serviceLastRef = "";
    await this.getServices();
  }

  async searchServices() {
    try {
      this.loadingServices = true;
      const servicesState = JSON.stringify(SERVICES_ORDER_TO_SHOW);
      const responseData = this.isInPanel
        ? await this.servicesService.getServicesByType(
            this.userId,
            "",
            "",
            this.serviceLastRef,
            this.searchQuery
          )
        : await this.servicesService.getServicesByType(
            this.userId,
            "",
            servicesState,
            this.serviceLastRef,
            this.searchQuery
          );

      if (responseData.code === Http.Found && responseData.data) {
        this.empty = false;

        const newServiceRef =
          responseData.data.length > 0
            ? responseData.data[responseData.data.length - 1].id
            : this.serviceLastRef;

        if (newServiceRef != this.serviceLastRef) {
          if (this.serviceLastRef !== "") {
            this.serviceLastRef =
              responseData.data[responseData.data.length - 1].id;
            this.generalData = [...this.generalData, ...responseData.data];
          } else {
            this.serviceLastRef = newServiceRef;
            this.generalData = [...responseData.data, ...this.generalData];
          }

          this.generalData = this.generalData.filter(
            (item, index, self) =>
              index === self.findIndex(t => t.id === item.id)
          );
          this.servicesList = this.orderAndGroupByState(responseData.data);
        } else {
          this.servicesList = this.orderAndGroupByState(this.generalData);
        }

        this.itemFilter.listItemFilterObj!.category = this.listCategory;
        this.itemFilter.listItemFilterObj!.state = this.listState;
        this.$emit(PROFILE_CONSTANTS.SERVICES_PROVIDED, this.generalData);
        if (this.serviceSelected !== "") {
          const service = this.servicesList.find(
            service => service.id === this.serviceSelected
          );
          if (service !== undefined && service.progress > 0) {
            this.dataToMainView = {
              from: this.isInPanel
                ? PANEL_INFO_CONSTANTS.FROM.PANEL
                : PANEL_INFO_CONSTANTS.FROM.PROFILE,
              type: PANEL_INFO_CONSTANTS.TYPE.SERVICE,
              action: PANEL_INFO_CONSTANTS.ACTION.SHOW_COMPLETE_BTN
            };
            this.$emit(
              PROFILE_CONSTANTS.EMIT_OPERATIONS.CHOSEN_SERVICE,
              this.dataToMainView
            );
          }
        }
        this.loadingServices = false;
      } else {
        this.empty = true;
        this.loadingServices = false;
        Snackbar.popInfo(responseData.message);
      }
      this.loading = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      this.empty = true;
      Snackbar.popError(errorMessage);
    }
    this.loadingServices = false;
  }

  async getServices() {
    try {
      this.loadingServices = true;
      const filterKeys = Object.keys(this.filtern);
      const filterKey = filterKeys[0];
      const filterText = this.filtern[filterKeys[0]];

      const filterQuery: ServiceQuery = {
        user: this.userId
      };

      if (!this.isInPanel)
        filterQuery.state = JSON.stringify(SERVICES_ORDER_TO_NOT_SHOW);
      if (filterKey == FILTERS_NAME.NAME) filterQuery.internalName = filterText;
      if (filterKey == FILTERS_NAME.CATEGORY) filterQuery.category = filterText;
      if (filterKey == FILTERS_NAME.STATUS)
        filterQuery.state = JSON.stringify(Array(filterText));
      if (this.serviceLastRef) filterQuery.lastReference = this.serviceLastRef;

      const responseData = await this.servicesService.getServicesByFilters(
        filterQuery
      );
      if (responseData.code === Http.Found && responseData.data) {
        this.empty = false;

        const newServiceRef = responseData.data.lastReference;

        if (newServiceRef != this.serviceLastRef) {
          if (this.serviceLastRef !== "") {
            this.serviceLastRef = responseData.data.lastReference;
            this.generalData = [
              ...this.generalData,
              ...responseData.data.serviceArray
            ];
          } else {
            this.serviceLastRef = newServiceRef;
            this.generalData = [...responseData.data.serviceArray];
          }

          this.generalData = this.generalData.filter(
            (item, index, self) =>
              index === self.findIndex(t => t.id === item.id)
          );
          this.servicesList = this.orderAndGroupByState(
            responseData.data.serviceArray
          );
        } else {
          this.servicesList = this.orderAndGroupByState(this.generalData);
        }

        this.itemFilter.listItemFilterObj!.category = this.listCategory;
        this.itemFilter.listItemFilterObj!.state = this.listState;
        this.SERVICE_CONTEXTUAL_KEY = this.SERVICE_CONTEXTUAL_KEY + 1;
        this.$emit(PROFILE_CONSTANTS.SERVICES_PROVIDED, this.generalData);
        if (this.serviceSelected !== "") {
          const service = this.servicesList.find(
            service => service.id === this.serviceSelected
          );
          if (service !== undefined && service.progress > 0) {
            this.dataToMainView = {
              from: this.isInPanel
                ? PANEL_INFO_CONSTANTS.FROM.PANEL
                : PANEL_INFO_CONSTANTS.FROM.PROFILE,
              type: PANEL_INFO_CONSTANTS.TYPE.SERVICE,
              action: PANEL_INFO_CONSTANTS.ACTION.SHOW_COMPLETE_BTN
            };
            this.$emit(
              PROFILE_CONSTANTS.EMIT_OPERATIONS.CHOSEN_SERVICE,
              this.dataToMainView
            );
          }
        }
        this.loadingServices = false;
      } else {
        this.loadingServices = false;
        Snackbar.popInfo(responseData.message);
      }
      this.setServiceSelectedToTop();
      this.loading = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      this.empty = true;
      Snackbar.popError(errorMessage);
    }
    this.loadingServices = false;
  }

  validationService(service: ServiceHeaderData) {
    return Boolean(
      (service.type === SERVICE_TYPES.SECTIONS_KEY &&
        this.allowSend.includes(service.state)) ||
        (service.type === SERVICE_TYPES.GROUPS_KEY &&
          this.stateList.includes(service.state)) ||
        (service.type === SERVICE_TYPES.GROUPS_KEY &&
          this.allowSend.includes(service.state))
    );
  }

  getServiceData(service: ServiceHeaderData) {
    const id = service.id;
    const name = service.internalName;
    const type = service.type;
    const progress = service.progress;
    const visualStateName = service.visualStateName;
    const state = service.state;
    const medicalAppointment = service.medicalAppointment;
    if (this.canSeeServiceDetail) {
      this.modalConfirmationText =
        PROFILE_CONSTANTS.DIALOG_MESSAGES.CHANGE_SERVICE_TEXT;
      this.modalConfirmationTitle =
        PROFILE_CONSTANTS.DIALOG_MESSAGES.CHANGE_SERVICE_TITLE;

      this.dataToMainView = {
        from: this.isInPanel
          ? PANEL_INFO_CONSTANTS.FROM.PANEL
          : PANEL_INFO_CONSTANTS.FROM.PROFILE,
        type: PANEL_INFO_CONSTANTS.TYPE.SERVICE,
        action: PANEL_INFO_CONSTANTS.ACTION.FILL,
        data: {
          id,
          type,
          name,
          progress,
          state,
          visualStateName,
          medicalAppointment
        }
      };

      if (this.serviceSelected !== id && this.serviceSelected !== "") {
        this.lastService = id;
        const validationResponse = this.watchServiceValidation();
        if (validationResponse == false) {
          this.dialogConfirmation = false;
          this.handleModalAccept();
        } else {
          this.dialogConfirmation = true;
        }
      } else if (this.serviceSelected === id) {
        return;
      } else {
        this.serviceSelected = id;
        this.$emit(
          PROFILE_CONSTANTS.EMIT_OPERATIONS.CHOSEN_SERVICE,
          this.dataToMainView
        );
      }
    }
  }

  handleModalAccept() {
    const validationResponse = this.watchServiceValidation();
    if (validationResponse == true) this.refreshServiceValidation();
    this.dialogConfirmation = false;
    this.serviceSelected = this.lastService;
    if (
      this.modalConfirmationTitle ===
      PROFILE_CONSTANTS.DIALOG_MESSAGES.COMPLETE_SERVICE_TITLE
    ) {
      this.dataToMainView = {
        from: this.isInPanel
          ? PANEL_INFO_CONSTANTS.FROM.PANEL
          : PANEL_INFO_CONSTANTS.FROM.PROFILE,
        type: PANEL_INFO_CONSTANTS.TYPE.SERVICE,
        action: PANEL_INFO_CONSTANTS.ACTION.COMPLETE,
        data: {
          id: this.serviceSelected
        }
      };
      this.refreshData();
    }
    if (
      this.modalConfirmationTitle ===
      PROFILE_CONSTANTS.DIALOG_MESSAGES.CANCEL_SERVICE_TITLE
    ) {
      this.dataToMainView = {
        from: this.isInPanel
          ? PANEL_INFO_CONSTANTS.FROM.PANEL
          : PANEL_INFO_CONSTANTS.FROM.PROFILE,
        type: PANEL_INFO_CONSTANTS.TYPE.SERVICE,
        action: PANEL_INFO_CONSTANTS.ACTION.CANCEL_SERVICE,
        data: {
          id: this.serviceSelected,
          medicalAppointment: this.appointmentService
        }
      };
      this.refreshData();
    }
    this.$emit(
      PROFILE_CONSTANTS.EMIT_OPERATIONS.CHOSEN_SERVICE,
      this.dataToMainView
    );
  }

  handleModalCancel() {
    this.dialogConfirmation = false;
  }

  changeServices(serviceFiltered: ServiceHeaderData[]) {
    this.servicesList = this.orderAndGroupByState(serviceFiltered);
  }

  @Watch("refresh")
  refreshData() {
    this.serviceSelected = this.serviceId ?? "";
    this.serviceLastRef = "";
    this.getServices();
  }

  @Watch("getMoreServices")
  async onBottomParent() {
    if (this.loadingServices) return;
    await this.getServices();
  }

  async appointmentOperations(service: ServiceHeaderData) {
    if (!service.requiredPriorOrder) {
      if (service.medicalAppointment && service.medicalAppointment !== "") {
        this.medicalAppointmentSelected = service.medicalAppointment;
        this.serviceTemplateSelected = "";
      } else {
        this.medicalAppointmentSelected = "";
        this.serviceTemplateSelected = service.serviceTemplateId as string;
        const responseData = await this.availabilityService.getCampusAvailables(
          this.serviceTemplateSelected
        );
        if (responseData.code !== Http.Found || !responseData.data) {
          Snackbar.popWarning(responseData.message);
          return;
        }
      }
      this.serviceNameSelected = service.internalName;
      this.showModalAppointment = true;
      this.serviceAppointment = service.id;
      this.currentService = service;
    }
  }

  async hideAppointmentModal(refreshList: boolean) {
    this.showModalAppointment = false;
    if (refreshList) {
      this.serviceSelected = this.serviceId ?? "";
      this.refreshServices();
      await this.getServices();
    }
  }

  hideMedicalOrderModal() {
    this.showModalMedicalOrder = false;
  }

  refreshServices() {
    store.commit(STORE_CONSTANTS.REFRESH_PROFILE_SERVICES);
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.PROFILE,
      type: PANEL_INFO_CONSTANTS.TYPE.SERVICE,
      action: PANEL_INFO_CONSTANTS.ACTION.REFRESH
    });
  }

  refreshServiceValidation() {
    store.commit(STORE_CONSTANTS.SERVICE_CHANGE_VALIDATION, false);
    store.commit(STORE_CONSTANTS.REFRESH_SERVICE_TEMPLATE, true);
  }

  showCompleteServiceModal(service: ServiceHeaderData) {
    this.lastService = service.id;
    this.modalConfirmationText =
      PROFILE_CONSTANTS.DIALOG_MESSAGES.COMPLETE_SERVICE_TEXT;
    this.modalConfirmationTitle =
      PROFILE_CONSTANTS.DIALOG_MESSAGES.COMPLETE_SERVICE_TITLE;
    this.dialogConfirmation = true;
  }

  async medicalOrderOperations(service: ServiceHeaderData) {
    if (service.medicalOrderId) {
      this.serviceTemplateSelected = service.serviceTemplateId as string;
      const response = await this.medicalOrderService.getMedicalOrderById(
        service.medicalOrderId
      );

      if (response.code == Http.Found) {
        this.medicalOrder = response.data as MedicalOrderPreviewEventTimelineModel;
        this.showModalMedicalOrder = true;
      }
      this.cupsId = service.cups ?? "";
    }
  }

  async showCompleteOrderServiceModal(service?: ServiceHeaderData) {
    if (service) {
      let medicalList;
      const filter = {
        serviceTemplate: service.serviceTemplateId
      };
      const res = await this.medicalOrderService.getMedicalOrderByFilter(
        filter
      );
      if (
        res.code == Http.Found ||
        (res != undefined && res.code == undefined)
      ) {
        const docref = res.data?.docref || "";
        const medicalOrder = await this.medicalOrderService.getMedicalOrderById(
          docref
        );
        medicalList = medicalOrder.data;
        this.orderUserId = medicalOrder.data?.user ?? "";
        store.commit(STORE_CONSTANTS.MEDICAL_ORDER_LIST_OBJECT, medicalList);
      }
    }
  }

  orderServiceValidation(service?: ServiceHeaderData) {
    this.medicalOrdersValidation = false;
    if (service) {
      const filter = {
        serviceTemplate: service.serviceTemplateId
      };
      this.medicalOrderService
        .getMedicalOrderByFilter(filter)
        .then(res => {
          if (
            res.code == Http.Found ||
            (res != undefined && res.code == undefined)
          )
            this.medicalOrdersValidation = true;
        })
        .catch(error => {
          const errorMessage =
            (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
              ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
              : FORM_MESSAGES.REQUEST_FAILED;

          this.empty = true;
          Snackbar.popError(errorMessage);
        });
    }
  }

  @Watch("medicalOrderValidation")
  closeOrderModal() {
    this.orderUserId = "";
    store.commit(STORE_CONSTANTS.MEDICAL_ORDER_VALIDATION, false);
  }

  alertNoPatientRol() {
    Snackbar.popError(ACTION_MESSAGE.NO_PATIENT_ROL);
    this.closeOrderModal();
  }

  async showPdfFile(docref?: string) {
    const response = await this.documentService.getDocumentsURL(docref ?? "");
    if (response.code == Http.Found && response.data) {
      this.openPreview(response.data);
    } else {
      return Snackbar.popError(response.message);
    }
  }

  openPreview(documentURL: string) {
    this.documentDialog = true;
    this.documentURL = documentURL;
    this.documentName = "";
  }
  closePreview() {
    this.documentDialog = false;
  }
  cancelService(serviceId: ServiceHeaderData) {
    this.lastService = serviceId.id;
    this.appointmentService = serviceId.medicalAppointment ?? "";
    this.modalConfirmationText =
      PROFILE_CONSTANTS.DIALOG_MESSAGES.CANCEL_SERVICE_TEXT;
    this.modalConfirmationTitle =
      PROFILE_CONSTANTS.DIALOG_MESSAGES.CANCEL_SERVICE_TITLE;
    this.dialogConfirmation = true;
  }

  async showServiceNotes(service: ServiceHeaderData) {
    try {
      this.eventData.type = this.SERVICE;
      this.eventData.title = service.internalName;
      this.eventData.refId = service.id;
      const notesReponse = await this.eventService.getNotesByServiceId(
        service.id
      );
      if (notesReponse.code === Http.Found && notesReponse.data) {
        Vue.set(this.eventData, this.NOTES, notesReponse.data.notes);
        this.showModalNotes = true;
        return;
      }
      Snackbar.popError(notesReponse.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + EVENTS_ACCESS.GET);
      else Snackbar.popError(EVENT_MESSAGES.REQUEST_FAILED);
    }
  }

  handleModalClose() {
    this.showModalNotes = false;
  }

  async onScroll(event: Event) {
    const target = event.target as HTMLElement;

    this.showGoTopBtn = target.scrollTop >= 100;
    if (
      target.scrollTop + target.clientHeight + 5 >= target.scrollHeight &&
      !this.loadingServices
    ) {
      target.scrollTop -= 3;
      await this.getServices();
    }
  }

  async onScrollCenter(event: Event) {
    const target = event.target as HTMLElement;
    if (
      target.scrollTop + target.clientHeight + 5 >= target.scrollHeight &&
      !this.loadingServices
    ) {
      target.scrollTop -= 3;
      await this.getServices();
    }
  }

  goToTop() {
    const target = document.getElementById(this.SERVICELIST_ID);
    if (target) {
      target.scrollTop = 0;
      this.showGoTopBtn = false;
    }
  }

  async openChangeStateServiceModal(service: ServiceHeaderData) {
    console.log("serviceTemplateId", service.serviceTemplateId);
    console.log("service", service);
    this.serviceToChangeState = service;
    this.showStateServiceModal = true;
  }

  closeStateServiceModal() {
    this.showStateServiceModal = false;
    this.serviceToChangeState = {} as ServiceHeaderData;
  }

  async validateUpdateStateService(serviceState: {
    id: string;
    state: string;
  }) {
    if (serviceState.state == "Completado") {
      const response = await this.serviceTemplateService.getServiceTemplateById(
        this.serviceToChangeState.serviceTemplateId!
      );
      console.log("response", response);
      if (response.code === Http.Found && response.data && response.data.rda) {
        this.serviceSelected = serviceState.id;
        this.specialistSignatureDialog = true;
        return;
      }
    }
    this.updateStateService(serviceState);
  }

  async updateStateService(serviceState: { id: string; state: string }) {
    try {
      console.log("updateServiceState", serviceState);
      const response = await this.servicesService.updateServiceState(
        serviceState
      );

      if (response.code === Http.Ok) {
        if (
          !this.isInPanel &&
          COMPLETE_SERVICE_TO_FILL.includes(serviceState.state)
        ) {
          const cloneGeneralData = _.cloneDeep(this.generalData);
          this.generalData = cloneGeneralData.filter(
            service => service.id !== serviceState.id
          );
        }

        store.commit(STORE_CONSTANTS.REFRESH_PROFILE_SERVICES);

        Snackbar.popSuccess(response.message);
      } else {
        Snackbar.popError(response.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.PUT}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
    this.closeStateServiceModal();
  }

  setMenuOpen(serviceId: string, value: boolean) {
    console.log("value", value);
    this.$set(this.menuOpenByServiceId, serviceId, value);
  }

  async createSummary(service: ServiceHeaderData) {
    this.$store.commit(STORE_CONSTANTS.CHAT_ACTION, {
      action: CHAT_ACTIONS.OPEN_CHAT,
      msgsStore: [
        {
          role: "user",
          content: `resumir el servicio ${service.internalName}`,
          context: {
            serviceId: service.id
          },
          functionCall: {
            name: "getServiceSummary"
          }
        }
      ]
    });
  }

  closeMenu(id: string) {
    this.isGeneratingSummary = false;
    this.summaryLoadingServiceId = "";
    this.setMenuOpen(id, false);
  }

  @Watch("dataToMainViewStore")
  setServiceSelectedToTop() {
    console.log("dataToMainViewStore", this.dataToMainViewStore);
    console.log(
      "general data",
      this.generalData.map(item => item.id)
    );

    this.serviceSelected = this.dataToMainViewStore?.data?.id || this.serviceId;
    const index = this.generalData.findIndex(
      service => service.id === this.serviceSelected
    );
    if (index == -1) {
      this.serviceSelected = "";
      return;
    }

    console.log("index", index);
    const newList = [...this.generalData];
    const [service] = newList.splice(index, 1);
    newList.unshift(service);

    this.generalData = newList;
    this.scrollTopAndSetGreenPointInList();
  }

  scrollTopAndSetGreenPointInList() {
    this.$nextTick(() => {
      const target = document.getElementById(this.SERVICELIST_ID);
      if (target) {
        target.scrollTo({
          top: 0,
          behavior: "auto"
        });
      }
    });
  }

  closeSpecialistSignatureDialog() {
    this.specialistSignatureDialog = false;
  }

  acceptSpecialistSignature(data: any) {
    if (data) {
      this.completeService(data);
    }
    this.specialistSignatureDialog = false;
  }

  async completeService(specialistId?: string) {
    try {
      const response = await this.servicesService.completeService(
        this.serviceSelected,
        specialistId ?? ""
      );

      if (response.code === Http.Ok) {
        Snackbar.popSuccess(response.message);
        this.serviceSelected = "";
        this.showStateServiceModal = false;
        store.commit(STORE_CONSTANTS.REFRESH_PROFILE_SERVICES);
      } else {
        this.serviceSelected = "";
        Snackbar.popWarning(response.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.PUT}`
          : FORM_MESSAGES.REQUEST_FAILED;
      this.serviceSelected = "";
      Snackbar.popError(errorMessage);
    }
  }
}
